import { getApiEndpoint } from "../utils/constants/api";
import { SHOP_SOURCES } from "../utils/constants/shopSources";
import { wfetch } from "../utils/fetch";

export const getCategories = async (opts) => {
    const { source } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;

        const res = await wfetch(getApiEndpoint("CATEGORIES", { queryParams: { lang } }));

        return res?.data?.results;
    }

    // External sources
    const res = await wfetch(getApiEndpoint("EXTERNAL_CATEGORIES", { pathParams: { source } }));

    return res?.data?.results && composeCategoriesTree(res.data.results, source);
};

export const getCategory = async (opts) => {
    const { source, categoryId } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;

        const res = await wfetch(getApiEndpoint("CATEGORIES", { queryParams: { lang, "@path": categoryId } }));

        return res?.data?.results && res?.data?.results[0];
    }

    // External sources
    const res = await wfetch(getApiEndpoint("EXTERNAL_CATEGORIES", { pathParams: { source, categoryId: encodeURIComponent(categoryId) } }));

    return res?.data;
};

export const composeCategoriesTree = (categories, source) => {
    if (source === SHOP_SOURCES.JCR) return categories;

    const map = categories.reduce((acc, item) => ({ ...acc, [item["@id"]]: { ...item, "@nodes": [] } }), {});

    return Object.values(
        categories.reduce((acc, { "@id": id, parentId }) => {
            if (parentId && acc[parentId]) {
                acc[parentId][id] = acc[id];
                acc[parentId]["@nodes"].push(id);
            }
            return acc;
        }, map),
    ).filter(({ parentId }) => !parentId);
};

export const getCategoryTreeIds = (category) => {
    const ids = new Set([]);

    if (category["@id"]) ids.add(category["@id"]);

    if (category["@nodes"] && category["@nodes"].length)
        category["@nodes"].forEach((nodeName) => category[nodeName] && ids.add(...getCategoryTreeIds(category[nodeName])));

    return ids;
};
